const formatDateUnit = (num) => {
  num += '';
  return num.length < 2 ? '0' + num : num;
};

const formatDateDay = (date) => {
  // if (date === null) return '-';
  if (!date) return null;
  let newDate = new Date((date + '').substring(0, 19));
  return (
    newDate.getFullYear() +
    '-' +
    formatDateUnit(newDate.getMonth() + 1) +
    '-' +
    formatDateUnit(newDate.getDate())
  );
  // let day = date.slice(0, 10);
  // let second = date.slice(11, 16);
  // return day + " " + second;
};
const formatDateDayWithDate = (newDate) => {
  // if (date === null) return '-';
  if (!newDate) return null;
  return (
    newDate.getFullYear() +
    '-' +
    formatDateUnit(newDate.getMonth() + 1) +
    '-' +
    formatDateUnit(newDate.getDate())
  );
  // let day = date.slice(0, 10);
  // let second = date.slice(11, 16);
  // return day + " " + second;
};
const formatDate = (date) => {
  // if (date === null) return '-';
  if (!date) return null;
  let newDate = new Date((date + '').substring(0, 19));
  return (
    newDate.getFullYear() +
    '-' +
    formatDateUnit(newDate.getMonth() + 1) +
    '-' +
    formatDateUnit(newDate.getDate()) +
    ' ' +
    formatDateUnit(newDate.getHours()) +
    ':' +
    formatDateUnit(newDate.getMinutes())
  );
  // let day = date.slice(0, 10);
  // let second = date.slice(11, 16);
  // return day + " " + second;
};

const formatDateSecond = (date) => {
  // if (date === null) return '-';
  if (!date) return null;
  let newDate = new Date((date + '').substring(0, 19));
  // let day = date.slice(0, 10);
  // let second = date.slice(11, 16);
  // let result2 = day + " " + second;
  let result =
    newDate.getFullYear() +
    '-' +
    formatDateUnit(newDate.getMonth() + 1) +
    '-' +
    formatDateUnit(newDate.getDate()) +
    ' ' +
    formatDateUnit(newDate.getHours()) +
    ':' +
    formatDateUnit(newDate.getMinutes()) +
    ':' +
    formatDateUnit(newDate.getSeconds());
  return result;
};
const formatDateSecondWithDate = (newDate) => {
  // if (date === null) return '-';
  if (!newDate) return null;
  // let day = date.slice(0, 10);
  // let second = date.slice(11, 16);
  // let result2 = day + " " + second;
  let result =
    newDate.getFullYear() +
    '-' +
    formatDateUnit(newDate.getMonth() + 1) +
    '-' +
    formatDateUnit(newDate.getDate()) +
    ' ' +
    formatDateUnit(newDate.getHours()) +
    ':' +
    formatDateUnit(newDate.getMinutes()) +
    ':' +
    formatDateUnit(newDate.getSeconds());
  return result;
};

const formatYM = (date) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }
  return date.getFullYear() + '-' + formatDateUnit(date.getMonth() + 1);
};
const formatYMD = (date) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }
  return (
    date.getFullYear() +
    '-' +
    formatDateUnit(date.getMonth() + 1) +
    '-' +
    formatDateUnit(date.getDate())
  );
};
const formatYMDHM = (date) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }
  return (
    date.getFullYear() +
    '-' +
    formatDateUnit(date.getMonth() + 1) +
    '-' +
    formatDateUnit(date.getDate()) +
    ' ' +
    formatDateUnit(date.getHours()) +
    ':' +
    formatDateUnit(date.getMinutes())
  );
};
const formatYMDHMS = (date) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }
  return (
    date.getFullYear() +
    '-' +
    formatDateUnit(date.getMonth() + 1) +
    '-' +
    formatDateUnit(date.getDate()) +
    ' ' +
    formatDateUnit(date.getHours()) +
    ':' +
    formatDateUnit(date.getMinutes()) +
    ':' +
    formatDateUnit(date.getSeconds())
  );
};

const formatHM = (date) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else if ((date + '').length === 19) {
    return (date + '').substr(11, 5);
  } else {
    date = new Date((date + '').substring(0, 19));
  }
  return (
    formatDateUnit(date.getHours()) + ':' + formatDateUnit(date.getMinutes())
  );
};

function formatYMDHMSWithObject(date) {
  if (!date || !date.date || !date.time) return date;

  let yy = date.date.year + '';
  let MM = date.date.month + '';
  let dd = date.date.day + '';
  let hh = date.time.hour + '';
  let mm = date.time.minute + '';
  let ss = date.time.second + '';

  if (MM.length < 2) MM = '0' + MM;
  if (dd.length < 2) dd = '0' + dd;
  if (hh.length < 2) hh = '0' + hh;
  if (mm.length < 2) mm = '0' + mm;
  if (ss.length < 2) ss = '0' + ss;

  return yy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss;
}

const AddYears = (date, value) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }

  date.setFullYear(date.getFullYear() + value);
  return date;
};

const AddMonths = (date, value) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }

  date.setMonth(date.getMonth() + value);
  return date;
};

const AddDays = (date, value) => {
  if (!date) return null;
  if (date instanceof Date) {
  } else {
    date = new Date((date + '').substring(0, 19));
  }

  date.setDate(date.getDate() + value);
  return date;
};

const GetMonthFirstDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

const GetMonthLastDate = (date) => {
  const nextMonthFirstDate = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    1
  );
  return new Date(nextMonthFirstDate - 1);
};

const GetWeekStartDate = (date) => {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() - date.getDay()
  );
};

const GetWeekEndDate = (date) => {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + (6 - date.getDay())
  );
};

const checkBetweenTime = (startDate, endDate) => {
  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (start > end) return;

  return start < now && now < end ? true : false;
};

export {
  formatDateDay,
  formatDateDayWithDate,
  formatDateSecondWithDate,
  formatYM,
  formatYMD,
  formatYMDHM,
  formatYMDHMS,
  formatYMDHMSWithObject,
  formatHM,
  formatDate,
  formatDateSecond,
  AddYears,
  AddMonths,
  AddDays,
  GetMonthFirstDate,
  GetMonthLastDate,
  GetWeekStartDate,
  GetWeekEndDate,
  checkBetweenTime,
};
